import React, { useState } from 'react';
import { reviews, type Review } from '../data/content';
import { SectionTitle } from './SectionTitle';
import { Stars } from './Stars';
import { Reveal } from './Reveal';
import { ReviewForm } from './ReviewForm';
const initials = (name: string) => name.replace('.', '').split(' ').map(part => part[0]).join('').slice(0, 2).toUpperCase();
function ReviewCard({
  review
}: {
  review: Review;
}) {
  return <article className="rounded-2xl border border-gold/20 bg-night p-5" data-id="element-128" data-mp="1bi6riazk5e2t">
      <div className="flex items-center gap-3" data-id="element-129" data-mp="16pwxojvbntv9">
        <span aria-hidden="true" className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-gold font-sans text-[15px] font-bold text-white" data-id="element-130" data-mp="16p3x60myi0lk">
          {initials(review.name)}
        </span>
        <div className="min-w-0" data-id="element-131" data-mp="wq62sh2uncun">
          <p className="font-sans text-[15px] font-semibold text-ivory" data-id="element-132" data-mp="sr5l51w3yg98">
            {review.name}
          </p>
          <p className="font-sans text-[13px] text-ivory/50" data-id="element-133" data-mp="nravt2rzdyqa">{review.city}</p>
        </div>
        <Stars className="ml-auto" data-id="element-134" data-mp="3ly4pr68vg92x" />
      </div>

      <p className="mt-4 font-sans text-[15px] leading-relaxed text-ivory/85" data-id="element-135" data-mp="3lxbscvvsyvxg">
        “{review.text}”
      </p>
      <p className="mt-3 font-sans text-[13px] text-ivory/40" data-id="element-136" data-mp="3qr7mtocuy0nv">{review.date}</p>
    </article>;
}
export function ReviewsSection() {
  const [showAll, setShowAll] = useState(false);
  const visible = showAll ? reviews : reviews.slice(0, 4);
  return <section className="bg-botanic px-5 py-10" data-id="element-137" data-mp="8ji7txcj2x22">
      <SectionTitle data-id="element-138" data-mp="8hnj07y4yksp">⭐ Quienes aplicaron esta guía nos recomiendan</SectionTitle>

      <div className="mt-6 space-y-3" data-id="element-139" data-mp="dibb6wy3p7oi">
        {visible.map((review, i) => <Reveal key={review.name} delay={i < 4 ? i * 80 : 0} data-id="element-140" data-mp="3vp93y3qq3pwp" data-mpi={i}>
            <ReviewCard review={review} data-id="element-141" data-mp="4i50fitselt1" />
          </Reveal>)}
      </div>

      {!showAll && <button type="button" onClick={() => setShowAll(true)} className="mt-6 w-full min-h-[56px] rounded-[14px] border border-gold/50 px-5 py-4 font-sans text-[16px] font-semibold text-gold transition-all duration-150 active:scale-[0.97] hover:bg-gold/10" data-id="element-142" data-mp="4k9akiia4h1r">
          Ver más reseñas ({reviews.length - 4})
        </button>}

      <ReviewForm data-id="element-143" data-mp="ptcdh7d8jo6v" />
    </section>;
}